import { get, patch, deleteRequest, useMock } from "../../../shared/data";
// import * as logger from '../../../shared/logger';
import moment from "moment";
import { lookupUUID } from "../../../shared/attribute-uuid";

const addOrder = (ref) => {
    ref.order = ref._seq || 0;

    return ref;
};

// TODO: Remove isIntake when GDN and wip are consistent
const flatten = (references, reference) => {
    if (reference) {
        const flattened = reference;

        if (flattened.isIntake) {
            flattened.age = "Current WIP";
            const brand = flattened[lookupUUID("brand")];
            flattened.brand = typeof brand === "string" ? brand : brand.hasOwnProperty("text") ? brand.text : "";
            const category = flattened[lookupUUID("inhouseCategories")];
            flattened.category = category ? category.map((v) => v.text).join(", ") : "";
            flattened.description = flattened[lookupUUID("description")] || flattened[lookupUUID("smDescription")];
            const manufacturer = flattened[lookupUUID("manufacturer")];
            flattened.manufacturer = typeof manufacturer === "string" ? manufacturer : manufacturer.hasOwnProperty("text") ? manufacturer.text : "";
            flattened.name = flattened["Gladson Product Name"];
            flattened.upc = flattened[lookupUUID("upc")];
        } else {
            const posted = moment(new Date(flattened.postdate)).utc();
            const today = moment();
            flattened.age = today.diff(posted, "days") || "-";
            flattened.brand = flattened.ecom_brand;
            flattened.description = flattened.description || flattened.sm_shortdescription;
            flattened.key = reference.key;
            flattened.manufacturer = flattened.sm_manufacturer;
            flattened.name = flattened["Gladson Product Name"];
            flattened.upc = flattened.upc || flattened.ecom_legacyupc;
        }

        references.push(flattened);
    }

    return references;
};

export const searchReferences = (params) => {
    // *** Params can be:
    // {
    //     description: "string",
    //     manufacturer: "string",
    //     productLine: "string",
    //     age: 0,
    //     upc: "string",
    // }
    let paramString = Object.entries(params)
        .filter(([key, val]) => {
            return val !== "";
        })
        .map(([key, val]) => {
            return `${key}=${encodeURIComponent(val)}`;
        })
        .join("&");
    const url = `/coding/referenceproducts?${paramString}`;

    return get(url).then((references) => {
        return references.reduce(flatten, []).map(addOrder);
    });
};

export const getReferences = (wipKey, taskKey) => {
    const params = taskKey ? `?taskKey=${taskKey}` : "";
    const url = useMock ? "/coding/product-references.json" : `/coding/wips/${wipKey}/references${params}`;
    return get(url, { useMock })
        .then((references) => {
            return references.reduce(flatten, []).map(addOrder);
        })
        .catch((e) => {
            return [];
        });
};

export const getSampleReferences = async (codingWipKey, upc) => {
    const sampleReferences = await searchReferences({ upc });
    const top3References = [];
    sampleReferences
        .filter((r) => r.key !== codingWipKey)
        .forEach((ref, index) => {
            if (index > 2) return;

            if (ref) {
                ref.order = index + 1;
                top3References.push(ref);
            }
        });

    return top3References;
};

export const addReferences = (wipKey, referenceIds) => {
    return patch(`/coding/wips/${wipKey}/references`, referenceIds);
};

export const deleteReference = (wipKey, referenceKey, taskKey) => {
    const params = taskKey ? `?taskKey=${taskKey}` : "";
    return deleteRequest(`/coding/wips/${wipKey}/references/${referenceKey}${params}`);
};
